import * as React from "react";
import { cn } from "~/lib/utils";
import { Input as InputComponent } from "../ui/input";
import { Textarea as TextareaComponent } from "../ui/textarea";
import { SelectTrigger as SelectTriggerComponent } from "../ui/select";

type InputProps = React.ComponentProps<typeof InputComponent>;
type TextareaProps = React.ComponentProps<typeof TextareaComponent>;
type SelectTriggerProps = React.ComponentProps<typeof SelectTriggerComponent>;

export function Input({ className, ...props }: InputProps) {
  return (
    <InputComponent
      className={cn("border border-gray-300 h-12 focus-visible:ring-gray-500 placeholder:text-gray-500", className)}
      {...props}
    />
  );
}

export function Textarea({ className, ...props }: TextareaProps) {
  return (
    <TextareaComponent
      className={cn(
        "border border-gray-300 focus-visible:ring-gray-500 placeholder:text-gray-500 min-h-24",
        className
      )}
      {...props}
    />
  );
}
